/**
 * @module M/control/LegendStyle
*/
import Draggabilly from 'draggabilly';
import LegendStyleImpl from 'impl/legendStyle';
import template from 'templates/stylelegend';
import { getValue } from './i18n/language';

const MAX_INPUT_LENGTH = 100;
export default class LegendStyle extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(plugin, options = {}) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(LegendStyleImpl)) {
      M.exception('La implementación usada no puede crear controles StyleToolsControl');
    }

    // 2. implementation of this control
    const impl = new LegendStyleImpl();
    super(impl, 'LegendStyle');
    this.plugin = plugin;
    this.size = 0.3; // default 0.3 in plugin "LegendImageTransformBase"
    this.color = options.color || '#000000';
    this.titleColor = options.titleColor || '#000000';
    this.textColor = options.textColor || '#000000';
    this.radioSelect = options.radioSelect || 'BottomLeftLegend';
    this.inputArray = options.inputArray;
    this.temporalAllF = options.temporalAllF;
    this.legendSVG = options.legendSVG;
    this.legendCount = options.legendCount;
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    this.lmap_ = map;
    this.generateTemporalALLF(true);
    let refreshButtonState = 'dontDisplayStyle';
    if (this.legendCount !== undefined && this.legendCount !== null && this.legendCount !== this.refreshLegendCount) {
      refreshButtonState = '';
    }
    const html = M.template.compileSync(template, {
      vars: {
        translations: {
          options: getValue('options'),
          colour: getValue('colour'),
          svgexample: getValue('svgexample'),
          border: getValue('border'),
          title: getValue('title'),
          text: getValue('text'),
          position: getValue('position'),
          disabled: getValue('disabled'),
          TopLeft: getValue('TopLeft'),
          TopRight: getValue('TopRight'),
          BottomLeft: getValue('BottomLeft'),
          BottomRight: getValue('BottomRight'),
          refresh: getValue('refresh'),
          accept: getValue('accept'),
          refreshWarning1: getValue('refreshWarning1'),
          refreshWarning2: getValue('refreshWarning2'),
        },
        refreshButtonState,
      },
    });

    const destroyPlugin = html.querySelector('button#destroy-plugin');
    const acceptPlugin = html.querySelector('div.group-row2 button#acceptButton');
    const functionDestroyPlugin = function(event) {
      this.plugin.destroyControl();
    };
    destroyPlugin.addEventListener('click', functionDestroyPlugin.bind(this));
    acceptPlugin.addEventListener('click', functionDestroyPlugin.bind(this));

    const showSVG = html.querySelector('div.group-row3 .showSVG');
    if (this.legendSVG) { // Generate SVG of Legend/leyenda
      showSVG.innerHTML = this.legendSVG;
    } else {
      this.legendSVG = this.generateLegend();
      showSVG.innerHTML = this.legendSVG;
    }

    const inputsElement = html.querySelector('div.style-col-3');
    const allInputTextsLength = html.getElementsByClassName('txtLgndEdit').length;
    const bindedLegend = this.generateLegend.bind(this);
    this.generateInputs = (num) => {
      const result = [];
      for (let j = 0; j < num; j += 1) {
        const inpt = document.createElement('input');
        inpt.setAttribute('value', this.inputArray[j]);
        inpt.setAttribute('type', 'text');
        inpt.setAttribute('maxLength', MAX_INPUT_LENGTH);
        // style and value default to add
        inpt.addEventListener('input', (inp) => {
          this.inputArray[j] = inp.target.value.substr(0, MAX_INPUT_LENGTH);
          clearTimeout(this.timerLegend);
          this.timerLegend = setTimeout(() => {
            this.legendSVG = bindedLegend();
            showSVG.innerHTML = this.legendSVG;
          }, 500);
        });
        const labelText = document.createElement('label');
        labelText.textContent = (j + 1) + ':';
        const simpleDiv = document.createElement('div');
        simpleDiv.append(labelText);
        simpleDiv.append(inpt);
        result.push(simpleDiv);
      }
      return result;
    };
    inputsElement.append(...this.generateInputs(allInputTextsLength));

    const refreshWarning = html.querySelector('div.group-row2 div.refreshWarning');
    const refreshButton = html.querySelector('div.group-row2 button#refreshButton');
    refreshButton.addEventListener('click', () => {
      refreshButton.classList.add('dontDisplayStyle');
      refreshWarning.classList.remove('dontDisplayStyle');
      this.temporalAllF = null;
      this.legendSVG = bindedLegend();
      showSVG.innerHTML = this.legendSVG;
      inputsElement.replaceChildren();
      const allInputTextsLength2 = html.getElementsByClassName('txtLgndEdit').length;
      inputsElement.append(...this.generateInputs(allInputTextsLength2));
    });

    const changeColor = function(color, name) {
      this[name] = color.value;
      this.legendSVG = bindedLegend();
      showSVG.innerHTML = this.legendSVG;
    };
    const color1 = html.querySelector('input.color1');
    const color2 = html.querySelector('input.color2');
    const color3 = html.querySelector('input.color3');
    color1.value = this.color;
    color2.value = this.titleColor;
    color3.value = this.textColor;
    color1.addEventListener('change', changeColor.bind(this, color1, 'color'));
    color2.addEventListener('change', changeColor.bind(this, color2, 'titleColor'));
    color3.addEventListener('change', changeColor.bind(this, color3, 'textColor'));

    const selectPosition = html.querySelector('div.selectPosition');
    selectPosition.children[1].value = this.radioSelect;
    selectPosition.children[1].addEventListener('change', () => {
      if (this.radioSelect == selectPosition.children[1].value) { return false; }
      this.radioSelect = selectPosition.children[1].value;
      this.legendSVG = bindedLegend();
      showSVG.innerHTML = this.legendSVG;
    });

    setTimeout(() => {
      const elem = document.querySelector('.m-panel.m-tools-styleTools');
      if (elem !== null) {
        const draggable = new Draggabilly(elem, {
          containment: '.m-mapea-container',
          handle: '#styleToolsHTML > div > div.title',
        });
        draggable.enable();
      }
    }, 300);
    return html;
  }

  generateTemporalALLF(checkRefresh = false) {
    const allF = this.temporalAllF && !checkRefresh ? this.temporalAllF : [[], [], [], []]; // RUTAS, PUNTOS, LINEAS, POLÍGONOS
    if (!this.temporalAllF || checkRefresh) {
      const filterRouteAndLine = []; const filterPoints = []; const filterPolygons = []; // Limpiado de duplicados
      this.lmap_.getLayers().filter((l) => {
        return (l.legend && l.legend.endsWith('(Líneas)')) || l.impl_.name == '__draw__' || l.from_parameters || l.layerAddedByEditionTools;
      }).forEach((l2) => {
        const auxAddRoute = (l2.legend && l2.legend.endsWith('(Líneas)')) ? 0 : 2; // 0 es Rutas, 2 es Líneas.
        l2.getFeatures().forEach((f) => {
          if (f.impl_.olFeature_.values_.geometry.getType().endsWith('LineString')) {
            let auxLine;
            if (f.impl_.olFeature_.style_ instanceof Array) {
              auxLine = f.impl_.olFeature_.style_[0].stroke_;
            } else {
              auxLine = f.impl_.olFeature_.style_.stroke_;
            }
            let auxWidth; let auxDash;
            if (f.impl_.olFeature_.realStyle) {
              if (f.impl_.olFeature_.realStyle.stroke_width) {
                auxWidth = f.impl_.olFeature_.realStyle.stroke_width;
              } else {
                auxWidth = auxLine.width_;
              }
              if (f.impl_.olFeature_.realStyle.dash) {
                auxDash = f.impl_.olFeature_.realStyle.dash.sizes;
              } else {
                auxDash = auxLine.lineDash_;
              }
            } else {
              auxWidth = auxLine.width_;
              auxDash = auxLine.lineDash_;
            }
            const auxString = auxLine.strokeEnd + '' + auxLine.color_.toLowerCase() + '' + auxWidth + (auxDash ? auxDash.join('') : '');
            if (filterRouteAndLine.indexOf(auxString) == -1) {
              filterRouteAndLine.push(auxString);
              allF[auxAddRoute].push({ strokeEnd: auxLine.strokeEnd, color_: auxLine.color_, width_: auxWidth, lineDash_: auxDash });// LINEAS o RUTAS
            }
          } else {
            if (f.impl_.olFeature_.values_.geometry.getType().endsWith('Polygon')) {
              if (f.impl_.olFeature_.style_.stroke_) {
                const auxPoly = f.impl_.olFeature_.style_;
                let auxWidth; let auxDash;
                if (f.impl_.olFeature_.realStyle) {
                  if (f.impl_.olFeature_.realStyle.stroke_width) {
                    auxWidth = f.impl_.olFeature_.realStyle.stroke_width;
                  } else {
                    auxWidth = auxPoly.stroke_.width_;
                  }
                  if (f.impl_.olFeature_.realStyle.dash) {
                    auxDash = f.impl_.olFeature_.realStyle.dash.sizes;
                  } else {
                    auxDash = auxPoly.stroke_.lineDash_;
                  }
                } else {
                  auxWidth = auxPoly.stroke_.width_;
                  auxDash = auxPoly.stroke_.lineDash_;
                }
                const auxString = auxWidth + '' + auxPoly.stroke_.color_ + (auxPoly.fill_.color_ instanceof Array ? auxPoly.fill_.color_.slice(0, 3).join('') + '' + auxPoly.fill_.color_[3] : auxPoly.fill_.color_) + (auxDash ? auxDash.join('') : '');
                if (filterPolygons.indexOf(auxString) == -1) {
                  filterPolygons.push(auxString);
                  allF[3].push({ stroke_: { width_: auxWidth, color_: auxPoly.stroke_.color_, lineDash_: auxDash }, fill_: { color_: auxPoly.fill_.color_ } });// POLÍGONOS
                }
              }
            } else {
              if (f.impl_.olFeature_.style_.image_) { // Punto con imagen, no texto
                let auxPoint;
                let auxString;
                if (f.impl_.olFeature_.style_.image_.fill_) {
                  auxPoint = f.impl_.olFeature_.style_.image_.fill_.color_;// PUNTOS
                  auxString = 'circle' + auxPoint;
                } else {
                  auxPoint = f.impl_.olFeature_.values_.icon;// PUNTOS
                  auxString = auxPoint.replace('<svg ', '<svg x="70" y="XYZ" ').replace(/(height|width)="[0-9]+(px)?"/g, (matched) => { return matched.replace(/\d+/, '40'); });
                }
                if (filterPoints.indexOf(auxString) == -1) {
                  filterPoints.push(auxString);
                  allF[1].push(auxPoint);// PUNTOS
                }
              }
            }
          }
        });
      });

      if (checkRefresh) {
        if (this.temporalAllF) { // compare previus and current features group styles
          if (this.temporalAllF[0].length === allF[0].length && this.temporalAllF[1].length === allF[1].length && this.temporalAllF[2].length === allF[2].length && this.temporalAllF[3].length === allF[3].length) {
            if (allF[0].length) { // RUTAS
              allF[0] = allF[0].filter((r, index) => {
                const r2 = this.temporalAllF[0][index];
                return (r.strokeEnd === r2.strokeEnd && r.color_ === r2.color_ && r.width_ === r2.width_ && r.lineDash_ === r2.lineDash_);
              });
            }
            if (allF[1].length) { // PUNTOS
              allF[1] = allF[1].filter((p, index) => {
                return (p === this.temporalAllF[1][index]);
              });
            }
            if (allF[2].length) { // LINEAS
              allF[2] = allF[2].filter((r, index) => {
                const r2 = this.temporalAllF[2][index];
                return (r.strokeEnd === r2.strokeEnd && r.color_ === r2.color_ && r.width_ === r2.width_ && r.lineDash_ === r2.lineDash_);
              });
            }
            if (allF[3].length) { // POLÍGONOS
              allF[3] = allF[3].filter((p, index) => {
                const p2 = this.temporalAllF[3][index];
                const auxCheckFillColor = (p.fill_.color_ instanceof Array ? p.fill_.color_.slice(0, 3).join('') + '' + p.fill_.color_[3] : p.fill_.color_) === (p2.fill_.color_ instanceof Array ? p2.fill_.color_.slice(0, 3).join('') + '' + p2.fill_.color_[3] : p2.fill_.color_);
                return (p.stroke_.width_ === p2.stroke_.width_ && p.stroke_.color_ === p2.stroke_.color_ && p.stroke_.lineDash_ === p2.stroke_.lineDash_ && auxCheckFillColor);
              });
            }
          } else { // Some length diference
            allF[0] = []; allF[1] = []; allF[2] = []; allF[3] = [];
          }
        }
      } else {
        this.temporalAllF = allF;
      }
    }
    if (checkRefresh) {
      this.refreshLegendCount = allF[0].length + allF[1].length + allF[2].length + allF[3].length;
      return undefined;
    }

    this.legendCount = allF[0].length + allF[1].length + allF[2].length + allF[3].length;
    return allF;
  }

  generateLegend() {
    const allF = this.generateTemporalALLF(); // Conseguir features y rutas.
    // Estilado puntos, lineas y polígonos además de rutas.
    const cntxt = document.createElement('canvas').getContext('2d');
    const fsText = 20;
    const fsTitle = 33; const titleHeightEdit = Math.ceil(fsTitle / 2);
    const fontFamily = 'sans-serif';
    const border = 4; const halfBorder = Math.round(border / 2);
    const padding = 27;
    const showFeature = 149;// Never smaller than 149px for DashStyles.
    const extraSizeStrokeEnd = 1; // Width Size 1 is to small

    const defaultTitle = 'LEYENDA';
    cntxt.font = fsTitle + 'px ' + fontFamily;
    const titleSize = cntxt.measureText(defaultTitle);
    const titleSizeW = Math.ceil(titleSize.width);
    const boxTitleColor = this.titleColor;
    const boxStrokeColor = this.color;
    const boxFillColor = '#ffffff';

    const defaultTexts = 'Texto';// 'Prueba de texto largo para los títulos del estilado';
    const hBorPad = halfBorder + padding;
    const between = 16;// Never smaller than 5px
    const endIcons = hBorPad + showFeature;
    const startText = endIcons + between;
    const textColor = this.textColor;
    cntxt.font = fsText + 'px ' + fontFamily;
    let totalW;
    const auxTotalFeatures = this.legendCount;
    if (this.inputArray) {
      if (this.inputArray.length !== auxTotalFeatures) {
        if (this.inputArray.length < auxTotalFeatures) {
          for (let j = this.inputArray.length; j < auxTotalFeatures; j += 1) {
            this.inputArray.push(defaultTexts + ' ' + (j + 1));
          }
        } else {
          const repeat = auxTotalFeatures - this.inputArray.length;
          this.inputArray.splice(repeat);
        }
      }
      let auxSizeM = -Infinity;
      for (let j = 0; j < this.inputArray.length; j += 1) {
        const auxSize = startText + Math.ceil(cntxt.measureText(this.inputArray[j]).width) + hBorPad;
        if (auxSize > auxSizeM) { auxSizeM = auxSize; }
      }
      const auxTitleSize = titleSizeW + (padding * 2) + border;
      if (auxSizeM < auxTitleSize) {
        totalW = auxTitleSize;
      } else {
        totalW = auxSizeM;
      }
    } else {
      if (auxTotalFeatures > 0) {
        let auxMaxDefaultWidth = 0;
        let tempAuxWidth;
        this.inputArray = new Array(auxTotalFeatures);
        for (let j = 0; j < this.inputArray.length; j += 1) {
          const auxDef = defaultTexts + ' ' + (j + 1);
          tempAuxWidth = cntxt.measureText(auxDef).width;
          if (tempAuxWidth > auxMaxDefaultWidth) {
            auxMaxDefaultWidth = tempAuxWidth;
          }
          this.inputArray[j] = auxDef;
        }
        totalW = startText + Math.ceil(auxMaxDefaultWidth) + hBorPad;
      } else {
        totalW = titleSizeW + (padding * 2) + border;
      }
    }

    let legendTextPos = totalW - titleSizeW;
    if (legendTextPos < 0) { legendTextPos = 0; } else { legendTextPos /= 2; }
    const legendTitleElement = '<text x="' + legendTextPos + '" y="' + (hBorPad + titleHeightEdit) + '" font-family="' + fontFamily + '" font-size="' + fsTitle + '" fill="' + boxTitleColor + '">' + defaultTitle + '</text>\n';

    const TD = ['<text class="txtLgndEdit" font-family="' + fontFamily + '" font-size="' + fsText + '" fill="' + textColor + '" x="' + startText + '" y="', '">', '</text>\n'];
    let h = hBorPad + (titleHeightEdit * 2);

    let result = '';
    let inputIndex = 0;

    let last = null;
    let lastSpace = 0;

    if (allF[1].length) { // PUNTOS
      allF[1].forEach((s, i) => {
        let auxGeneretedLine;
        if (s.length > 10) {
          auxGeneretedLine = this.clasificadoSVG(s, 'MALC' + i).replace('<svg ', '<svg x="85" y="' + h + '" ').replace(/(height|width)="[0-9]+(px)?"/g, (matched) => { return matched.replace(/\d+/, '40'); }) + TD[0] + (h + 25) + TD[1];
        } else {
          auxGeneretedLine = '<circle cx="105" cy="' + (h + 20) + '" r="20" fill="' + s + '"/>' + TD[0] + (h + 24) + TD[1]; // Limpiado 'stroke="#ffffff" stroke-width="3"' ya que no es importante y se alinea mejor sin estos
        }
        result = result + auxGeneretedLine + this.inputArray[inputIndex] + TD[2];
        h += 50;
        inputIndex += 1;
      });
      last = 1;
    }
    if (allF[0].length || allF[2].length) { // RUTAS o LINEAS
      const lineFunction = (s) => {
        let auxTermination = '';
        let simpleLineSeparator;
        if (s.strokeEnd) { // Tener en cuenta la terminación
          const doubleStroke = (s.width_ + extraSizeStrokeEnd) * 2;
          simpleLineSeparator = endIcons - doubleStroke;
          if (s.strokeEnd == 'triangle') {
            const cuadStroke = (s.width_ + extraSizeStrokeEnd) * 4;
            auxTermination = '<path fill="' + s.color_ + '" d="M' + (endIcons - cuadStroke) + ' ' + (h - doubleStroke) + ' ' + endIcons + ' ' + h + ' ' + (endIcons - cuadStroke) + ' ' + (h + doubleStroke) + 'Z"/>';
          } else if (s.strokeEnd == 'circle') {
            auxTermination = '<circle fill="' + s.color_ + '" r="' + doubleStroke + '" cx="' + simpleLineSeparator + '" cy="' + h + '"/>';
          } else if (s.strokeEnd == 'square') {
            const cuadStroke = (s.width_ + extraSizeStrokeEnd) * 4;
            auxTermination = '<rect fill="' + s.color_ + '" x="' + (endIcons - cuadStroke) + '" y="' + (h - doubleStroke) + '" height="' + cuadStroke + '" width="' + cuadStroke + '"/>';
          }
        } else {
          simpleLineSeparator = endIcons - (s.width_ * 0.5);
        }

        const auxGeneretedLine = '<line x1="' + (hBorPad + (s.width_ * 0.5)) + '" x2="' + simpleLineSeparator + '" stroke-linecap="round" y1="' + h + '" y2="' + h + '" stroke="' + s.color_ + '" stroke-width="' + s.width_ + (s.lineDash_ ? '" stroke-dasharray="' + s.lineDash_.join(' ').replace(/^1 /, '0 ').replace(' 1 ', ' 0 ') : '') + '"/>' + auxTermination + TD[0] + (h + 5) + TD[1] + this.inputArray[inputIndex] + TD[2];
        result += auxGeneretedLine;
        h += 40;
        inputIndex += 1;
        lastSpace = s.width_ * 0.5;
      };

      if (last === null) {
        h += 9;// Separado para título
      } else if (last === 1) {
        h += 3;// Separado para puntos
      }
      if (allF[0].length) { // RUTAS
        allF[0].forEach(lineFunction);
        last = 0;
      }
      if (allF[2].length) { // LINEAS
        if (last === 0) h -= 3; // Separado para rutas
        allF[2].forEach(lineFunction);
        last = 2;
      }
    }
    if (allF[3].length) { // POLÍGONOS
      if (last == 0 || last == 2) { h -= 17; }// Separado para rutas y lineas
      allF[3].forEach((s) => {
        result = result + '<rect x="' + (hBorPad + (s.stroke_.width_ * 0.5)) + '" width="' + (showFeature - s.stroke_.width_) + '" height="30" stroke-linecap="round" y="' + h + '" stroke="' + s.stroke_.color_ + '" stroke-width="' + s.stroke_.width_ + '" fill="rgb(' + (s.fill_.color_ instanceof Array ? s.fill_.color_.slice(0, 3).join(' ') + ')" fill-opacity="' + s.fill_.color_[3] : s.fill_.color_.split(/, |\(|\)/).slice(1, 4).join(' ') + ')" fill-opacity="' + s.fill_.color_.match(/\d+\.*\d*/g)[3]) + (s.stroke_.lineDash_ ? '" stroke-dasharray="' + s.stroke_.lineDash_.join(' ').replace(/^1 /, '0 ').replace(' 1 ', ' 0 ') : '') + '"/>' + TD[0] + (h + 20) + TD[1] + this.inputArray[inputIndex] + TD[2];
        h += 42;
        inputIndex += 1;
        lastSpace = s.stroke_.width_ * 0.5;
      });
      last = 3;
    }

    let endSpace = 0;
    if (last == null) {
      endSpace = (hBorPad - 22);
    } else if (last == 3) {
      endSpace = Number.parseInt((hBorPad + lastSpace) - 12, 10);
    } else if (last == 0 || last == 2) { endSpace = Number.parseInt((hBorPad + (lastSpace * 3)) - 40, 10); }

    const totalH = h + endSpace;
    const legendBoxElement = '<rect width="' + totalW + '" height="' + totalH + '" stroke="' + boxStrokeColor + '" fill="' + boxFillColor + '" stroke-width="' + border + '"/>\n';
    result = '<?xml version="1.0" encoding="iso-8859-1"?><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="' + (totalW * this.size).toFixed() + '" height="' + (totalH * this.size).toFixed() + '" viewBox="0 0 ' + totalW + ' ' + totalH + '">\n' + legendBoxElement + legendTitleElement + result + '</svg>';
    return result;
  }

  clasificadoSVG(stringSVG, prefix) {
    return stringSVG.substring(stringSVG.indexOf('<svg')).replace(/\r\n|\r|\n/g, ' ') // Remove any starting text wich would cause visibility errors and clear lines
      .replace(/<svg.+?>/, svgStart => svgStart.replace(/(x|y)="\d+"/g, '')) // Remove repeating attributes
      .trim() // Clear for future operations
      .replace(/(id|class)=["']([^"^']*)["']/ig, '$1="' + prefix + '$2"') // Rename classes atributes
      .replace(/<style.+<\/style>/ig, styleObtained => styleObtained.replace(/(#|\.)(-?[_a-zA-Z]+[_a-zA-Z0-9-]*)(?=[^}]*{)/g, '.' + prefix + '$2')); // Rename style clases
  }

  getLegendToSend() {
    if (this.radioSelect !== 'NOTHING') {
      return { type: this.radioSelect, svg: this.legendSVG };
    }
    return undefined;
  }

  getAllParameters() {
    return {
      radioSelect: this.radioSelect,
      textColor: this.textColor,
      titleColor: this.titleColor,
      color: this.color,
      inputArray: this.inputArray,
      temporalAllF: this.legendCount === 0 ? undefined : this.temporalAllF,
      legendSVG: this.legendSVG,
      legendCount: this.legendCount,
    };
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof LegendStyle;
  }
}
